<template>
	<div class="index">
		<div class="layui-layout layui-layout-admin" style="display: flex;flex-wrap: wrap;">
			<div class="layui-header zt_color layui-row" style="width:100%;box-shadow: 0 1px 3px 0px rgba(0,0,0,0.3);position: fixed;top: 0;left: 0;">
				<div class="layui-logo f_row al_itm pointer" style="color:#fff;width:auto;">
					<img src="../assets/logo.png" style="margin: 0 10px 0 20px;" height="40" width="40" alt="">
					<span class="px20">桃琼之瑶SMT活动钢网区域战略合作伙伴</span>
				</div>
				<ul class="layui-nav layui-layout-right">
					<li @click="help" class="layui-nav-item" lay-unselect>
						<a href="javascript:;" class="px16 f_row al_itm"> <i class="layui-icon layui-icon-help px24"></i>&nbsp;疑问解答</a>
					</li>
					<li @click="clearSckey" class="layui-nav-item">
						<a href="javascript:;" class="px16 f_row al_itm"> <i class="iconfont icon-guanji layui-icon-close-fill px24"></i>&nbsp;退出登录</a>
					</li>
				</ul>
			</div>
			<div class="layui-side layui-bg-gray" style="padding-top: 60px;">
				<div class="layui-side-scroll">
					<!-- 左侧导航区域（可配合layui已有的垂直导航） -->
					<ul class="layui-nav layui-nav-tree layui-nav-side px18" lay-filter="test" style="padding-top: 60px;box-sizing: border-box;">
						<li v-for="(item,index) in tabList" :key="index" class="layui-nav-item" :class="item.path == path ? 'layui-this' : ''">
							<router-link  :to="{ path: item.path }">
								<img :src="item.path == path ? item.img1 : item.img2" alt="" width="30" height="30">
								<span class="px16" style="width:80px;text-align:left;padding-left:20px;">{{item.names}}</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="layui-body" style="flex: 1;padding-top: 60px;">
				<div id="marquee">
					<div><i class="layui-icon layui-icon-speaker"></i></div>
					<marquee onmouseover="this.stop()" onmouseout="this.start()" scrollamount="4">
						<p v-for="item in notice" v-html="item.content"></p>
					</marquee>
				</div>
				<!-- 内容主体区域 -->
				<div class="white">
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive"></router-view>
					</keep-alive>
					<router-view v-if="!$route.meta.keepAlive"></router-view>
				</div>
			</div>
		</div>
		<div id="qrCode" v-if="qrcode">
			<i class="el-icon-error close" @click.stop="onCloseQrCode"></i>
			<div id="QQ">
				<a target='_blank' href='http://wpa.qq.com/msgrd?v=3&amp;site=qq&amp;menu=yes&amp;uin=2951682271' title='在线即时交谈'><i
					 class="layui-icon layui-icon-login-qq"></i>在线客服</a>
			</div>
			<img src="../assets/qrcode.png" title="打开微信扫一扫，关注公众号绑定手机号接收消息推送" />
			<p style="font-size: 12px;">扫码关注微信公众号<br />绑定账号接收消息提醒</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				qrcode: true,
				tab_index: 1,
				tabList: [{
						id: 1,
						names: '会员中心',
						img1: require('@/assets/a/1a.png'),
						img2: require('@/assets/a/1b.png'),
						icon: 'layui-icon-friends',
						path: '/memberCenter'
					},
					{
						id: 2,
						names: '任务大厅',
						img1: require('@/assets/a/3a.png'),
						img2: require('@/assets/a/3b.png'),
						icon: 'layui-icon-cart-simple',
						path: '/creatOrder'
					},
					{
						id: 3,
						names: '我的订单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-form',
						path: '/myOrder'
					},
					{
						id: 4,
						names: '售后订单',
						img1: require('@/assets/a/4a.png'),
						img2: require('@/assets/a/4b.png'),
						icon: 'layui-icon-form',
						path: '/salesOrder'
					},
					{
						id: 5,
						names: '等级评分',
						img1: require('@/assets/a/5a.png'),
						img2: require('@/assets/a/5b.png'),
						icon: 'layui-icon-file',
						path: '/score'
					},
					{
						id: 6,
						names: '收入明细',
						img1: require('@/assets/a/5a.png'),
						img2: require('@/assets/a/5b.png'),
						icon: 'layui-icon-file',
						path: '/salary'
					},
					{
						id: 7,
						names: '注册资料',
						img1: require('@/assets/a/8a.png'),
						img2: require('@/assets/a/8b.png'),
						icon: 'layui-icon-file',
						path: '/memberLog'
					},
					{
						id: 9,
						names: '修改密码',
						img1: require('@/assets/a/7a.png'),
						img2: require('@/assets/a/7b.png'),
						icon: 'layui-icon-auz',
						path: '/setpsword'
					},
					{
						id: 10,
						names: '材料管理',
						img1: require('@/assets/a/5a.png'),
						img2: require('@/assets/a/5b.png'),
						icon: 'layui-icon-auz',
						path: '/materMent'
					},
					{
						id: 11,
						names: '地址管理',
						img1: require('@/assets/a/5a.png'),
						img2: require('@/assets/a/5b.png'),
						icon: 'layui-icon-auz',
						path: '/sites'
					}
				],
				path: '/memberCenter',
				notice: ''
			}
		},
		mounted() {
			let that = this;
			layui.use(['element'], () => {
				var element = layui.element;
				element.render();
			});
			if (!sessionStorage.tests) {
				this.$router.replace('login');
			} else {
				this.path = this.$route.path;
			}
			this.onNotice();
		},
		watch: { //监听路由变化
			$route(to, from) {
				this.path = this.$route.path;
				layui.use(['element'], () => {
					var element = layui.element;
					element.render();
				});
			}
		},
		methods: {
			help() {
				window.open("https://mr.summary88.com/mrgw_gcd/#/help");
			},
			onNotice() {
				let _this = this;
				api.notice({
					token: this.getCookie('token'),
				}).then((res) => {
					if (res.code == 1) {
						_this.notice = res.data;
					}
				})
			},
			clearSckey() {
				sessionStorage.clear('tests');
				this.delCookie('token');
				this.$router.replace({
					path: '/login'
				})
			},
			onCloseQrCode() {
				this.qrcode = false;
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#marquee {
		position: fixed;
		width: calc(100% - 220px);
		height: 40px;
		background: #fffbe8;
		top: 60px;
		left: 220px;
		z-index: 1001;
		font-size: 14px;
		display: flex;
		align-items: center;
		color: #ed6a0c;
	}

	#marquee div {
		width: 60px;
		text-align: right;
	}

	#marquee div i {
		font-size: 24px;
	}

	#marquee marquee {
		width: 100%;
		height: 40px;
	}

	#marquee p {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		margin-right: 50px;
	}

	.currents {
		background: #494E62;
	}

	.white {
		padding: 40px 15px 15px;
	}

	#qrCode {
		width: 120px;
		position: fixed;
		bottom: 80px;
		right: 0;
		background: #FFFFFF;
		border-radius: 5px;
		padding: 5px;
		z-index: 10000;
		text-align: center;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
		cursor: pointer;
	}

	#qrCode #QQ {
		width: 120px;
		height: 40px;
		color: #FFFFFF;
		background: #4876FF;
		border-radius: 5px;
		margin-bottom: 10px;
		box-sizing: border-box;
		padding: 0 10px;
	}

	#qrCode #QQ a {
		display: flex;
		align-items: center;
		height: 40px;
		line-height: 40px;
		color: #FFFFFF;
	}

	#qrCode #QQ a i {
		font-size: 30px;
		margin-right: 10px;
	}

	#qrCode img {
		width: 120px;
		height: 120px;
	}

	#qrCode .close {
		position: absolute;
		bottom: -30px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/components/index.vue